'use client';

import ConsentBanner from './components/consent-banner';
import ConsentManager from './components/consent-manager';

export default function CookieConsent() {
  return (
    <>
      <ConsentBanner />
      <ConsentManager />
    </>
  );
}
